import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Inbox as InboxIcon, Search, Settings, Menu } from "lucide-react";

/**
 * Mobile-only bottom tab bar. Hidden on md+ where the sidebar is already visible.
 */
export default function MobileTabBar({ onInboxTab, onSearchTab, onMenuTab }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const canAdmin = user && user.role === "owner";

  const Item = ({ icon: Icon, label, onClick, testId }) => (
    <button
      onClick={onClick}
      className="flex-1 h-full flex flex-col items-center justify-center gap-0.5 text-zinc-600 hover:text-[#0033CC] active:bg-zinc-100 transition-colors"
      data-testid={testId}
    >
      <Icon className="w-5 h-5" strokeWidth={1.75} />
      <span className="text-[10px] font-medium">{label}</span>
    </button>
  );

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 border-t border-zinc-200 bg-white z-20 flex safe-bottom"
      style={{ height: "calc(56px + env(safe-area-inset-bottom, 0px))" }}
      data-testid="mobile-tab-bar"
    >
      <Item icon={InboxIcon} label="Inbox" onClick={onInboxTab} testId="tab-inbox" />
      <Item icon={Search} label="Search" onClick={onSearchTab} testId="tab-search" />
      <Item icon={Menu} label="Menu" onClick={onMenuTab} testId="tab-menu" />
      {canAdmin && (
        <Item icon={Settings} label="Admin" onClick={() => navigate("/admin")} testId="tab-admin" />
      )}
    </nav>
  );
}
